export default __webpack_public_path__ + "static/media/signin.e65db9bf.svg";